import { RouterProvider } from "@tanstack/react-router";
import { Providers, type ProvidersProps } from "./providers.tsx";
import { createAppRouter } from "./router.tsx";

const router = createAppRouter();

export function App(props: Partial<Omit<ProvidersProps, "children">>) {
  return (
    <Providers {...props}>
      <RouterProvider router={router} />
    </Providers>
  );
}
